var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$route.name.startsWith('index'))?_c('SectionFeatures'):_vm._e(),_vm._v(" "),_c('NewsletterSubscribe'),_vm._v(" "),_c('FooterColumns'),_vm._v(" "),_c('FooterCopyright'),_vm._v(" "),_c('FooterNotice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }